var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerXMarkFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.703 10.621a1.015 1.015 0 000-1.423.985.985 0 00-1.406 0l-1.797 1.82-1.797-1.82a.985.985 0 00-1.406 0 1.015 1.015 0 000 1.423l1.798 1.82-1.736 1.757a1.015 1.015 0 000 1.423.985.985 0 001.406 0l1.735-1.757 1.735 1.757a.985.985 0 001.406 0 1.015 1.015 0 000-1.423l-1.736-1.757 1.798-1.82zM13 4.412c0-.89-1.077-1.337-1.707-.707l-4 4a1 1 0 01-.707.293H5a2 2 0 00-2 2v4a2 2 0 002 2h1.586a1 1 0 01.707.293l4 4c.63.63 1.707.183 1.707-.707V4.412z",
    fill: "currentColor"
  })));
}
export default SvgSpeakerXMarkFill;